import Error from 'components/form/Error';
import { DefaultLoader, LoaderContainer } from 'components/Loader';
import { PageBack, PageHeadContainer, PageTitle } from 'components/PageHead';
import React, { FC, useContext, useMemo } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import useSWR from 'swr';
import Interview from 'types/Interview';
import Accepted from './Accepted';
import Cancelled from './Cancelled';
import Head from './Head';
import Late from './Late';
import NoAnswer from './NoAnswer';
import Refused from './Refused';
import ReviewEdit from './ReviewEdit';
import WaitingMentee from './WaitingMentee';

const PageBackContainer = styled.div`
  margin-bottom: auto;
  font-size: 1.5rem;
`;

type ContextType = {
  interview: Interview | undefined;
};
export const ReviewPageContext = React.createContext({} as ContextType);
const { Provider } = ReviewPageContext;

const ReviewPage: FC = ({ children }) => {
  const { id } = useParams();
  const { data: interview, error } = useSWR<Interview>(
    `/interview/details/mentor/${id}`,
  );

  const [searchParams] = useSearchParams();

  const value = useMemo(
    () => ({
      interview,
    }),
    [interview],
  );
  return !error ? (
    interview ? (
      <Provider value={value}>{children}</Provider>
    ) : (
      <LoaderContainer>
        <DefaultLoader size={1.5} />
      </LoaderContainer>
    )
  ) : (
    <>
      <PageHeadContainer>
        <PageTitle>
          <PageBackContainer>
            <PageBack
              href={
                searchParams.get('from') ||
                '/mentor/mentorship/management/interviews'
              }
            />
          </PageBackContainer>
          <h1>Entretien</h1>
        </PageTitle>
      </PageHeadContainer>
      <Error>Une erreur est survenue.</Error>
    </>
  );
};

const DisplayedPage: FC = () => {
  const { interview } = useContext(ReviewPageContext);

  switch (interview?.status) {
    case 'WAITING_MENTEE':
    case 'WAITING_MENTOR':
      return <WaitingMentee />;
    case 'REFUSED':
      return <Refused interview={interview} />;
    case 'ACCEPTED':
      return <Accepted />;
    case 'WAITING_REVIEW':
    case 'FINISHED':
      return <ReviewEdit />;
    case 'NO_ANSWER':
      return <NoAnswer />;
    case 'CANCELLED':
      return <Cancelled />;
    case 'LATE':
      return <Late />;
    default:
      return null;
  }
};

const Usage: FC = (props) => {
  return (
    <ReviewPage {...props}>
      <Head />
      <DisplayedPage />
    </ReviewPage>
  );
};

export default Usage;
